import React from 'react';
import Typography from '../Typography';
import { Author } from '../../../models/article';
import Image from '../Image';
import { useStyles, cx } from '../../../lib/styles';

import storyBylineStyles from './StoryByline_styles';
import { formatArticleDate } from '../../../lib/dateUtilities';

export interface StoryBylineProps {
  amp?: boolean;
  author: Author;
  onAuthorClick?: () => any;
  created?: string;
}

const StoryByline = ({
  amp,
  author: { name, avatar_48, avatar_96, link },
  onAuthorClick,
  created,
}: StoryBylineProps) => {
  const styles = useStyles(storyBylineStyles());

  return (
    <div className={cx('StoryByline', styles.container)}>
      <a
        onClick={() => onAuthorClick && onAuthorClick()}
        href={link}
        title={name}
      >
        <Image
          amp={amp}
          src={avatar_96 || avatar_48 || ''}
          aspect={[1, 1]}
          width={40}
          height={40}
          resizeWidth={40}
          color={'white'}
          corner={'f'}
          border={'grey'}
        />
      </a>

      <div>
        <Typography>
          <small>
            <a
              onClick={() => onAuthorClick && onAuthorClick()}
              href={link}
              title={name}
            >
              {name}
            </a>
          </small>
        </Typography>

        {created && (
          <Typography>
            <small>{formatArticleDate(created)}</small>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default StoryByline;
